import { Link } from "react-router-dom";
import SmartImage from "@/components/base/SmartImage";

export default function BrandStory() {
  return (
    <section className="bg-background-50 py-14 md:py-16">
      <div className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-stretch">
          <div className="lg:col-span-8">
            <div className="relative w-full h-[340px] md:h-[560px] lg:h-[620px] overflow-hidden bg-background-100">
              <SmartImage
                src="https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/25fb42e1-7481-484a-8122-2113c117b563_compressed_home-field-story-alpine-trail-web.webp"
                alt="Field tested"
                tone="dark"
                imgClassName="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="lg:col-span-4 px-5 md:px-10 lg:pl-10 lg:pr-14 pt-8 lg:pt-0 flex flex-col justify-end">
            <p className="text-[10px] tracking-[0.24em] uppercase text-foreground-400 mb-4">Field Story — No. 04</p>
            <h2 className="text-[28px] md:text-[30px] leading-[1.12] tracking-[-0.01em] text-foreground-50 font-light mb-4">
              Two hundred kilometers of quiet weather along the Alta Via.
            </h2>
            <p className="text-[15px] md:text-[14px] text-foreground-300 leading-relaxed mb-6 max-w-sm">
              Our field team spent the shoulder season retracing an alpine route in shell, midlayer and pack — the release you see today came back changed.
            </p>
            <Link
              to="/journal/alta-via-two-hundred"
              className="inline-flex items-center gap-2 text-[13px] text-foreground-50 hover:text-primary-400 transition cursor-pointer whitespace-nowrap w-fit border-b border-foreground-300/50 hover:border-primary-400 pb-1"
            >
              Read the story <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}